import React from 'react';

import AluminiTalk2024  from 'views/AluminiTalk2024';
const ExtraCurricularActivitiesPage = () => {
  return <AluminiTalk2024 />;
};

export default ExtraCurricularActivitiesPage;